import Footer from '../Components/Footer';
import Header from '../Components/Header';
import seniorwing from '../images/srbuilding.jpg';

function SeniorWingSchool() {
    return (
        <>
            <Header />

            {/* Senior Wing Section */}
            <section style={{animation:'fadeIn 1s ease-in-out'}}>
                <div className='container-fluid' style={{ background: '#002147' }}>
                    <div className='row'>
                        <div className='col-12'>
                            <h4 className="text-center text-uppercase py-3" style={{ color: 'white', fontSize: '20px', fontWeight: 'bold' }}>Senior Wing</h4>
                        </div>
                    </div>
                </div>
                <div className="container-fluid wing px-0">
                    <div id="carouselExampleControlsNoTouching" className="carousel slide" data-bs-touch="false">
                        <div className="carousel-inner">
                            <div className="carousel-item active">
                                <img src={seniorwing} className="d-block w-100" alt="..." />
                            </div>
                        </div>
                    </div>
                    <p>The senior block is an architectural masterpiece which overlooks the beautifully landscaped lush garden.
                        It houses a state of the art reception area with a comfortable and lively space for the visitors
                        providing them with a glimpse of motivational views and blogs on the display board. It houses 40 well
                        ventilated and naturally lighted rooms to accommodate a class of 40 enthusiastic learners. The senior
                        secondary is a microcosm of outside world albeit a sheltering, caring one. The senior school curriculum
                        synergies seamlessly with various social, cultural and sporting activities providing an ambient learning
                        environment. Students have options of Science, Commerce, and Humanities inclusive of current competitive
                        subjects like Informatics Practices, Bio -Technology, Business Studies along with the other technical
                        subjects, preparing the students to venture out and face the world and be an exemplary citizen.</p>

                    <h4>The Library in Senior Block</h4>
                    <p>"Any book that helps a child to form a habit of reading, to make reading one of his deep and continuing
                        needs, is good for him" - Maya Angelou. In order to keep pace with the ever growing need of these
                        veritable store house of knowledge, two l one catering to the needs of the secondary classes and the
                        other exclusively keeping in mind the middle classes are functional where students feel perfectly at
                        ease as they browse through volumes on varied subjects. Apart from the reference work that the students
                        often indulge in, they gladly await the days on which they visit this temple of knowledge just to ease
                        themselves by reading the wonderful collections laid open before them.</p>

                    <h4>Infirmary</h4>
                    <p>To cope with any wayward situation the school has well equipped infirmary with a trained staff to assist
                        in any kind of emergency. Periodic checkups are carried out under the supervision of highly qualified
                        doctors.</p>

                    <h4>Art Room</h4>
                    <p>Art speaks where words are unable to explain. Two art rooms ignite the spark of creativity and
                        imagination in the hearts and minds of the budding artists. The students are taught the various
                        traditional and modern art forms.</p>

                    <h4>Music Room</h4>
                    <p>When words fail, music speaks – Shakespeare. With the same notion, a soulful space is provided in the
                        form of two music rooms for the learners where they can express their individuality and interpret music
                        through their emotions. They are made proficient in the various genres of music and made dexterous in
                        the various musical instruments.</p>

                    <h4>Dance Room</h4>
                    <p>‘Dance enables you to find yourself and lose yourself at the same time’. The students of senior block
                        channelise their energy in the various foot tapping and soulful dance forms in the futuristic dance
                        room, where they learn and imbibe the culture and tradition of different regions.</p>

                    <h4>Lab Block</h4>
                    <p>The ever-questioning mind of the children are not satisfied by just propounding theory. Theory
                        complemented with practical experiment and inference forms the best mode of imparting education. The
                        Science Labs, well equipped and built with the purpose of resolving the problems, enable the students to
                        reach their inferences, thus helping them in their learning process.</p>

                    <h4>Resource Lab</h4>
                    <p>This lab specially designed to equip the educators, offers an opportunity to nourish their teaching –
                        learning skills, providing them with latest updates and help them to maintain the school records.</p>

                    <h4>Computer Lab</h4>
                    <p>The school houses modern computer labs with a substantial number of computers equipped with the latest
                        technology to ensure that the students keep abreast with the fast changing IT world. The application of
                        IT in the educational sector has expanded the walls of the classrooms and created limitless
                        opportunities for learning and growth through the web based technology. The computer labs add to this
                        fervor of Information Technology.</p>

                    <h4>Physics Lab</h4>
                    <p>The spacious and bright Physics lab is the favourite haunt for all the Newtons in the making, where they
                        experiment and come out with new inferences.</p>

                    <h4>Chemistry Lab</h4>
                    <p>A well equipped chemistry lab, operational with test-tubes ,and other common chemical apparatus finds
                        many aspiring scientists engrossed in experimentation . Apart from these, the lab is modernized with a
                        fume chamber and electrical balances. The lab will soon be equipped with a pH meter and a distillation
                        set.</p>

                    <h4>Biology Lab</h4>
                    <p>A very interesting corner of learning, where unfolds the greatest mysteries of life. It is here that each
                        young learner watches with wonder the first signs of life under the microscope.</p>

                    <h4>Biotech Lab</h4>
                    <p>The room of a new concept, an interestingly new subject where the DNA structures unravel myriads of
                        mysteries and experimentation on improved genetics attracts the attention of young learners.</p>

                    <h4>Maths Lab</h4>
                    <p>Complying to the new concept of adding a Maths lab , as maintained by the CBSE board, an attractive room
                        full of evidences to show that mathematics can be fun, exists within the Lab- block.</p>

                    <h4>Geography Lab</h4>
                    <p>The Lab block houses a well resourced geography lab with maps, charts, OHP, survey equipment, weather
                        instruments, globes and other teaching aids where the students can travel up the blue Nile with their
                        fingers tracing the route through the hills, valleys, deserts and oceans.</p>

                    <h4>Auditorium</h4>
                    <p>A stage par excellence inviting the budding artists to exhibit their talent in a well-defined auditorium
                        with a capacity of accommodating approximately more than 500 students, find its place on the top floor
                        of the Lab block. Equipped with an effective light and sound system, it is a treat to witness the
                        cultural filigree sitting in the cool atmosphere of the auditorium.</p>

                    <h4>Play Ground</h4>
                    <p>School playgrounds are not merely a place for students to let off steam or hang out during recess.
                        Rather, a fun, safe playground environment stimulates students' minds and allows for their cognitive,
                        physical, and social development. In fact, outdoor play areas provide children with rich opportunities
                        to grow, learn, and develop. We believe in the propagation of an all round development of a child. With
                        our vast sprawling green grounds, the school playground provides a safe outdoors environment within the
                        school that stimulates children to use their creative energy in generating good physical health and
                        healthy interactions with one another. The school owns a lovely green carpeted cricket field, a foot
                        ball ground, basketball court, a volleyball court and a skating rink.</p>

                    <h4>Volleyball Courts</h4>
                    <p>Two volleyball courts of 18 x 9 mts each in the sprawling grounds of the school serve as the right
                        platform for the students.</p>

                    <h4>Tennis Courts</h4>
                    <p>Two tennis courts invite students to ease the rush of blood in the field .</p>

                    <h4>Gymnastic Floor</h4>
                    <p>Under the guidance of a gymnastics coach the students master flexibility and show their skills.</p>

                    <h4>Indoor Games</h4>
                    <p>Different team activities and provision of training in various indoor games like Chess, Carrom & Ludo
                        provides ample chance to the students to enjoy the intricacies of games.</p>

                    <h4>Athletics</h4>
                    <p>Various track and field activities motivate the students to remain energised and give their best.</p>

                    <h4>Table Tennis Court</h4>
                    <p>The four table tennis tables in the T.T Court gives ample chance to the players to juggle the T.T ball
                        and learn the intricacies of the game.</p>

                    <h4>Football Ground</h4>
                    <p>The white ball of Soccer takes a smooth ride on the green carpet of the ground and here the students are
                        trained in the kick and head of the game of football.</p>

                    <h4>Basketball Court</h4>
                    <p>Latest state of the art basketball court lends the athletes a chance to tap into their inner potential
                        and find their true calling. The two basketball courts adorn the games field of the school. The strong
                        iron poles on both the sides tempt the students to aim their goals high and hence they learn precision.
                    </p>

                    <h4>Cricket Pitch</h4>
                    <p>Cricket being the first love of Indians the school hosts a 22 yards pitch for a sound exposure of
                        students to this international game. It also caters to the concept of net practice, therefore two net
                        practice pitches find a place in the arena.</p>
                </div>
            </section>

            <Footer />
        </>
    )
}

export default SeniorWingSchool;